import type { TFAQ } from "~/components/sections/FAQ/index.vue";

export function createFAQSchema(items: TFAQ) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": items.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer
            }
        }))
    }
};